@if (vap && vapQuestion) {
  <div class="question">
    @for (savedItem of miniFlowSavedItems; track savedItem) {
      @if (editItemId === savedItem?.item_id && !lastItemId) {
        <app-vaps-mini-flow-player
          [classId]="vap?.class_id"
          [vapId]="vap?.product_vaps_id"
          [flowId]="vapQuestion?.child_flow_id"
          [editItemId]="editItemId"
          [productId]="productId"
          (flowComplete)="onFlowComplete($event)">
        </app-vaps-mini-flow-player>
      }
      @if (savedItem?.item_id !== editItemId) {
        <div class="question-saved" style="margin: 20px 0 10px">
          <div class="question-saved__content">
            @if (savedItem?.icon) {
              <div class="question-saved__icon">
                <img [src]="savedItem?.icon" class="icon" />
              </div>
            }
            <div class="question-saved__name">
              <h6 class="font-16">{{savedItem?.description_1}}</h6>
              <small>{{savedItem?.description_2}}</small>
              <div class="question-saved__actions d-none d-md-block">
                @if (+savedItem?.allow_edit === 1) {
                  <a
                    href="javascript:void(0);"
                    class="text-link"
                    (click)="edit(savedItem?.item_id)">
                    Edit
                  </a>
                }
                @if (+savedItem?.allow_delete === 1) {
                  <span>|</span>
                }
                @if (+savedItem?.allow_delete === 1) {
                  <a
                    href="javascript:void(0);"
                    class="action-remove text-link"
                    (click)="removeBenefit(savedItem?.item_id)">
                    Remove
                  </a>
                }
              </div>
            </div>
            <div class="question-saved__cost d-none d-md-block">
              <p><strong>{{ questionService?.accounting ? questionService?.accounting?.formatMoney(savedItem?.premium) : 'R '+savedItem?.premium}}</strong> /{{ questionService?.currency ? questionService?.currency?.display_freq : 'mo'}}</p>
            </div>
          </div>
          <!-- mobile actions and cost tray-->
          <div class="question-saved__tray d-md-none">
            <div class="question-saved__actions">
              @if (+savedItem?.allow_edit === 1) {
                <a
                  href="javascript:void(0);"
                  class="text-link"
                  (click)="edit(savedItem?.item_id)">
                  Edit
                </a>
              }
              @if (+savedItem?.allow_delete === 1) {
                <span>|</span>
              }
              @if (+savedItem?.allow_delete === 1) {
                <a
                  href="javascript:void(0);"
                  class="action-remove text-link"
                  (click)="removeBenefit(savedItem?.item_id)">
                  Remove
                </a>
              }
            </div>
            <div class="question-saved__cost">
              <p><strong>{{questionService?.accounting ? questionService?.accounting?.formatMoney(savedItem?.premium) : 'R '+savedItem?.premium}}</strong> /{{questionService?.currency ? questionService?.currency?.display_freq : 'mo'}}</p>
            </div>
          </div>
        </div>
      }
    }
    @if (lastItemId && !editItemId && showAddAnother) {
      <app-vaps-mini-flow-player
        [classId]="vap?.class_id"
        [vapId]="vap?.product_vaps_id"
        [flowId]="vapQuestion?.child_flow_id"
        [lastItemId]="lastItemId"
        [productId]="productId"
        (flowComplete)="onFlowComplete($event)">
      </app-vaps-mini-flow-player>
    }
  </div>
}
